import { Injectable, inject, DOCUMENT } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CookieOptions, CookieService } from 'ngx-cookie';
import * as CryptoJS from 'crypto-js';
import { Observable, retry } from 'rxjs';
import { HttpHeaders } from "@angular/common/http";
import { ConfigService } from '@neworg-net/amsuite-core/config';
import { requireHostUrl } from '../shared/required-host-url';

@Injectable({
  providedIn: 'root'
})
export class AppB2cService {
  private _document = inject(DOCUMENT);
  private _cookieService = inject(CookieService);
  private _http = inject(HttpClient);
  private readonly config = inject(ConfigService);


  public serverBaseUrl = this.getServerBaseUrl;
  private chatUrl = this.getServerBaseUrl + '/Chat';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
  }

  public get getServerBaseUrl(): string {
    return requireHostUrl(this.config, 'gatewayB2C');
  }

  getHeaders(): HttpHeaders {
    const authToken = this.getCookie('authToken');

    return new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Accept': '*/*',
      'Authorization': `Bearer ${authToken}`
    });
  }

  startChat(params: any): Observable<any> {
    const url = `${this.chatUrl}/StartChat`;
    const httpOptions = { headers: this.getHeaders() };

    return this._http.post(url, params, httpOptions).pipe(
      retry(2)
    );
  }

  startProviderChat(params: any): Observable<any> {
    const url = `${this.chatUrl}/StartChatServiceProvider`;
    const httpOptions = { headers: this.getHeaders() };

    return this._http.post(url, params, httpOptions).pipe(
      retry(2)
    );
  }

  sendMessage(params: any): Observable<any> {
    const url = `${this.chatUrl}/SendMessage`;
    const httpOptions = { headers: this.getHeaders() };

    return this._http.post(url, params, httpOptions).pipe(
      retry(2)
    );
  }



  //#region Cookie
  /**
* @param {string} key Id to use for lookup.
* @returns {string} Raw cookie value.
*/
  getCookie(key: string) {
    const cookie = this._cookieService.get(key);

    try {
      const decryptedValue = this.decryptValue(cookie);
      return decryptedValue && decryptedValue.trim().length > 0 ? decryptedValue : cookie;

    } catch (e) {
      return cookie;
    }
  }



  encryptValue(value: string): string {
    const key = CryptoJS.enc.Utf8.parse(this.config.cryptingKey);
    const encrypted = CryptoJS.AES.encrypt(value, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }


  decryptValue(value: string): string {
    const key = CryptoJS.enc.Utf8.parse(this.config.cryptingKey);
    const decrypted = CryptoJS.AES.decrypt(value, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  //#endregion
}
